import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const LEFT_COLUMN_SIZE = 214;
const TABLE_WIDTH_OFFSET_MEDIUM = LEFT_COLUMN_SIZE + 32; // 32 is the padding on both sides
// this is correct; there's more padding at this large size than extra large
const TABLE_WIDTH_OFFSET_LARGE = 675; // 472px plus 48px plus 155px min-width for StatsBarLeftColumn
const TABLE_WIDTH_OFFSET_EXTRA_LARGE = 627; // 472px plus 155px min-width for StatsBarLeftColumn

export const StatsBarTop = styled.div`
    align-items: center;
    // The background is theme.Text.OppositeSurface.secondary but with an opacity
    background: rgba(152, 152, 158, 0.1);
    border-radius: 8px;
    color: ${({ theme }) => theme.Text.primary};
    display: flex;
    flex-direction: row;
    max-width: 824px;
    margin: auto;
    min-height: 64px;
    position: static;

    ${BaseStyle.Mixins.screenSizes.small} {
        width: calc(100vw - 32px);
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        width: calc(100vw - 482px);
        position: absolute;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        width: calc(100vw - 490px); // I don't know where these last 8 px come from
    }
`;

export const StatsBarBottom = styled(StatsBarTop)`
    ${BaseStyle.Mixins.screenSizes.large} {
        top: 80px;
    }
`;

export const StatsBarLeftColumn = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
    padding: 16px;
    margin: auto;
    text-align: center;
    min-width: 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: 155px;
        width: ${LEFT_COLUMN_SIZE}px;
        padding: 12px;
    }
`;

export const FeaturedStatsTableContainer = styled.div`
    .rt-table {
        text-align: center;
    }

    .sortable-table-header {
        height: 14px;
    }

    .rt-thead .rt-tr .rt-th,
    .rt-td {
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        width: calc((100vw - 32px) / 5);

        &:first-child {
            border: none;
        }

        ${BaseStyle.Mixins.screenSizes.medium} {
            width: calc((100vw - ${TABLE_WIDTH_OFFSET_MEDIUM}px) / 5);
        }

        ${BaseStyle.Mixins.screenSizes.large} {
            width: calc((100vw - ${TABLE_WIDTH_OFFSET_LARGE}px) / 5);
        }

        ${BaseStyle.Mixins.screenSizes.extraLarge} {
            width: calc((100vw - ${TABLE_WIDTH_OFFSET_EXTRA_LARGE}px) / 5);
        }
    }

    .rt-thead .rt-tr .rt-th {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
    }

    .rt-tbody .rt-tr {
        align-items: center;
        height: 36px;
    }

    .rt-td {
        ${BaseStyle.Mixins.fontStyles.ui['24b']}

        ${BaseStyle.Mixins.screenSizes.small} {
            font-size: clamp(16px, 7vw, 24px);
        }

        ${BaseStyle.Mixins.screenSizes.medium} {
            font-weight: 900;
        }

        line-height: 36px; //overrides a value elsewhere that was causing a gap to appear in the vertical borders in this table
    }
`;
